/**
 * The 14 flow nodes of the pilgrim route (2026-10-08: no Boddu Bomma, no VIP entrance; Rajiv Gandhi Park and the holding area added) (entry gates → sanctum → dispersal) and the camera
 * checkpoints (backend/config/checkpoints.json) that count each one. A node with no mapped camera
 * must show "NO CAMERA", never an estimate. Add checkpoint ids here as cameras are installed.
 */
export const NODE_CHECKPOINTS: Record<string, string[]> = {
  "STN-MAIN": ["RAIL-EXIT-WALLCLOCK", "RAIL-EXIT-EAST-T1-LION", "RAIL-EXIT-EAST-T1-LION-UG", "RAIL-EXIT-EAST-T1-DHARNA", "RAIL-EXIT-EAST-T1-HALDIRAMS", "RAIL-EXIT-EAST-T1-PRASADAM"],
  "STN-ET2": ["RAIL-EXIT-EAST-T2"],
  "STN-PARCEL": ["RAIL-EXIT-SOUTH"],
  // west side of the station; the two "entry" cameras (10.245.9.133 / .137) were added on 11 Oct 2026
  "STN-THARA": ["RAIL-EXIT-WEST-T1", "RAIL-EXIT-WEST-T2", "RAIL-EXIT-WEST-ROAD", "RAIL-WEST-T1-ENTRY", "RAIL-WEST-T2-ENTRY"],
  // every bus-stand camera except Rajiv Gandhi Park (its own node): the top cards add up the same checkpoints
  "PNBS": ["PNBS-RAIL-ENTRY", "PNBS-KRISHNALANKA-PS", "PNBS-E3-FOOD-ROAD", "PNBS-MAIN-ENTRY", "PNBS-RAIL-SIDE"],
  "LOCAL": ["KUMMARI-JN"],
  "GADDE": ["GEDDABOMMA"],
  "VINAYAKA": ["VINAYAKA"],
  "RGPARK": ["PNBS-RAJIV-GANDHI-PARK"],   // bus station -> Rajiv Gandhi Park -> holding area
  // people entering the holding area: the entry camera 192.168.2.83; its exit is in NODE_EXIT_CHECKPOINTS
  "HOLDING": ["HOLDING-POINT-1-ENTRY"],
  // where the queue line starts: camera 192.168.2.102 ("Vinayaka Junction Queue Line 1")
  // Kummaripalem & ghats come into their own queue line, camera 192.168.2.47 (operators, 16 Oct 2026); both
  // queue lines lead to the temple, and from the temple there is one exit for everybody
  "QLINE-K": ["CP-VIEW-2-47"],
  "QLINE": ["CP-VINAYAKA-QUEUE-START", "CP-OM-TURNING-ENTRY", "CP-OM-QUEUE-START", "CP-OM-ENTRY-65", "CP-OM-ENTRY-74", "CP-QUEUE-JUNCTION"],
  // the temple: people arriving at 192.168.3.120 "Om Turning Temple Entry" (16 Oct 2026; was the queue-line cameras 2.38 + 2.41)
  "TEMPLE": ["CP-VIEW-3-120"],
  // people leaving the temple: the two Antharalayam exit cameras, 192.168.2.44 + 192.168.2.125 (the same as "Darshan Completed")
  "EXIT-KDN": ["CP-TEMPLE-ANTARALAYAM-EXIT", "CP-VIEW-2-125"],
  // (Kanaka Durga Nagar exit, 192.168.0.213, removed from the route on 16 Oct 2026 - operators)
};

/** Nodes with an exit camera of their own. Their card shows people in (NODE_CHECKPOINTS) and people out
 *  (these), each camera read in its busier direction, instead of the two directions of the entry camera. */
export const NODE_EXIT_CHECKPOINTS: Record<string, string[]> = {
  // the holding area's exit: camera 192.168.2.52 ("Holding Area 1 Exit"), 12 Oct 2026. Not 192.168.2.63
  // (HOLDING-POINT-1-EXIT): that one is view-only with no counting line and reads 0.
  "HOLDING": ["CP-HA1-CAM-2-52"],
};

/** Nodes counted by one-way queue cameras inside the temple: each checkpoint is read in whichever
 *  direction most people cross its line, so the figure does not depend on how the line was drawn. */
export const NODE_DOMINANT = new Set(["HOLDING", "QLINE", "QLINE-K", "TEMPLE", "EXIT-KDN"]);

/** What "toward" means at each node (the line's positive direction). Kept short: it shares the
 *  card's bottom row with the day totals. Nodes not listed read "to temple". */
export const NODE_TOWARD_LABEL: Record<string, string> = {
  "STN-MAIN": "out", "STN-THARA": "out", "STN-ET2": "out", "STN-PARCEL": "out",
  "PNBS": "out", "RGPARK": "to holding", "HOLDING": "in", "QLINE": "in queue", "QLINE-K": "in queue", "TEMPLE": "darshan", "EXIT-KDN": "out",
};
